import { render } from "./kids_orders.vue?vue&type=template&id=1254f426&scoped=true"
import script from "./kids_orders.vue?vue&type=script&lang=js"
export * from "./kids_orders.vue?vue&type=script&lang=js"

import "./kids_orders.vue?vue&type=style&index=0&id=1254f426&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1254f426"]])

export default __exports__